<template>
    <v-container color="primary">
        <v-row justify-md="center" wrap>
            <v-col cols="1" xs="0" sm="0" md="1">
            </v-col>
            <v-col cols="10" xs="12" sm="12" md="10">
                <materialfy-header-card cardTitle='BOTS' text="Here is a subtitle for this table" cardMinWidth="250"
                    :cardShowInnerList="false" :cardShowDivider="false">
                    <template v-slot:crdInner>
                        <br>
                        <v-divider class="mx-4" horizontal></v-divider>
                        <br>
                        <MaterialfyDataTables ref="dataTable" cardTitle="API" :showSearch="false" :actions="actions"
                            @action-clicked="handleActionClicked" :showCardTitle="false" />
                        <br>
                    </template>
                    <template #crdActions>
                        <br>
                        <v-divider class="mx-4" horizontal></v-divider>
                        <br>
                        <v-row no-gutters justify="center">
                            <v-btn @click="toHistoric">HISTORICO</v-btn>
                        </v-row>
                        <br>
                        <v-divider class="mx-4" horizontal></v-divider>
                        <br>
                    </template>
                </materialfy-header-card>
                <!-- <v-snackbar v-model="snackbar" :color="color" :bottom="bottom" :top="top" :float-left="left"
                    :float-right="right">
                    <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
                    <div>
                        {{ msg_toast }}
                    </div>
                    <v-icon size="16" @click="snackbar = false">
                        mdi-close-circle
                    </v-icon>
                </v-snackbar> -->
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import UserService from '@/services/user.service'

export default {
    name: "BotsView",
    data: () => ({
        title: 'Bots',
        headers: [
            { text: "Par", value: "bot.pair", align: "center" },
            { text: "Cantidad por Trade", value: "bot.quantity", align: "center" },
            { text: "Cantidad Bot", value: "bot.amount", align: "center" },
            { text: "En marcha", value: "bot.started", align: "center" },
            { text: "% Compra", value: "bot.buy", align: "center" },
            { text: "% Venta", value: "bot.sell", align: "center" },
            { text: 'Acciones', value: 'actions', sortable: false, align: "center" }
        ],
        items: [],
        actions: [
            { icon: 'mdi-call-made', tooltip: 'Odenes', action: 'orders' },
            { icon: 'mdi-content-save-edit-outline', tooltip: 'Modificar', action: 'update' },
            { icon: 'mdi-trash-can-outline', tooltip: 'Eliminar', action: 'delete' }
        ],
        search: '',
    }),
    mounted() {
        this.prepareData()
    },

    methods: {
        prepareData() {
            UserService.getListBots().then(
                response => {
                    if (response.data !== '') {
                        this.items = response.data
                        this.$refs.dataTable.headers = this.headers
                        this.$refs.dataTable.items = this.items
                    }
                },
                error => {
                    this.content =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();

                    if (error.response && error.response.status === 403 || error.response.status === 401) {
                        this.$store
                            .dispatch('logout', this.user) //calls the login action and passes login info
                            .then(() => this.$router.push('/')) //redirect to dash after login
                            .catch((err) => {
                                console.log(err)
                                this.snackbar = true //shows error on wrong pass
                            })
                    }
                }
            );
        },
        handleActionClicked({ item, action }) {
            switch (action) {
                case 'orders':
                    // this.$router.push('/orders/' + value.bot.id)
                    this.$router.push('/bots-orders/' + item.bot.id)
                    break;
                case 'update':
                    // console.log(value.bot)
                    if (!item.bot.automatico) {
                        this.$router.push('/bot-save/?idSuscripcion=' + item.id + '&tipo=estandard');
                    } else {
                        this.$router.push('/bot-save/?idSuscripcion=' + item.id + '&tipo=auto');
                    }

                    break;
                case 'delete':
                    this.bot = item.bot
                    this.openDialogQuestion()
                    break;
            }
        },
        openDialogQuestion() {
            this.$refs.dialogQuestions.openModal()
            this.$refs.dialogQuestions.component = 'DELETE_BOT'
            this.$refs.dialogQuestions.tituloDialog = 'Eliminar Bot'
            this.$refs.dialogQuestions.question = '¿ Desea realmente eliminar el bot ?'
        },
        eliminarBot() {
            UserService.deleteBot(this.bot).then(
                response => {
                    this.content = response
                    setTimeout(() => (this.responseDelete('success', this.content)), 2000)
                },
                error => {
                    this.content =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                    setTimeout(() => (this.responseDelete('error', this.content)), 2000)
                }
            );
        },
        responseDelete(response, msg) {
            this.$refs.dialogMessages.openModal()
            this.$refs.dialogMessages.component = 'ELIMINAR BOT'
            this.$refs.dialogMessages.tituloDialog = 'ELIMINAR BOT'
            this.$refs.dialogMessages.msgError = msg
            this.$refs.dialogMessages.isShow = true
            if (response === 'success') {
                this.$refs.dialogMessages.types = 'success'
                this.successful = true
            } else {
                this.$refs.dialogMessages.types = 'error'
                this.successful = false
            }
        },
        closeAlert() {
            if (this.successful) {
                this.successful = false
                this.itemsTable = []
                this.prepareData()
            }
        },
        toHistoric() {
            this.$router.push('/bots-historics');
        }
    },
};
</script>

<style></style>
